import React from 'react';
import DefaultProps from '../../commonTypes/defaultprops.types';
import { PortalProps } from '../Portal/portal.types';
import { BackdropProps } from './Backdrop/backdrop.types';
import { CloseButtonProps } from './CloseButton/closeButton.types';
import { ModalContentProps } from './ModalContent/modalContent.types';

export interface ModalProps extends DefaultProps {
  BackdropComponent?: React.ComponentType<BackdropProps>;
  backdropEventType?: string;
  backdropProps?: BackdropProps;
  CloseButtonComponent?: React.ComponentType<CloseButtonProps>;
  closeButtonProps?: CloseButtonProps;
  ContentComponent?: React.ComponentType<ModalContentProps>;
  contentProps?: ModalContentProps;
  disableBackdropClick?: boolean;
  disablePortal?: boolean;
  disableScrollbarWidthOffset?: boolean;
  disableScrollLock?: boolean;
  height?: ModalContentProps['height'];
  hideBackdrop?: boolean;
  hideCloseButton?: boolean;
  isCentered?: boolean;
  isOpen: boolean;
  onClose: (params: { event: Event; reason: ModalCloseReasons }) => void;
  PortalComponent?: React.ComponentType<PortalProps>;
  portalProps?: PortalProps;
  position?: ModalContentProps['position'];
  scrollType?: ScrollType;
  width?: ModalContentProps['width'];
}
export type ContainerProps = Omit<ModalProps, 'onClose' | 'isOpen'>;

export type ModalCloseReasons = 'backdropClick' | 'closeButtonClick' | 'escapeKeyPress';

export enum ScrollType {
  CONTAINER = 'container',
  CONTENT = 'content',
}
